import { useEffect, useState } from 'react';
import { getFormFieldConfig } from '../modules/phan-he-vien-phi/services/PhanHeVienPhiServices';

type Props = {
	code: string;
};

const useWorkflowOrgConfig = ({ code }: Props) => {
	const [config, setConfig] = useState<any>();

	useEffect(() => {
		getWorkflowOrgConfig(code);
	}, []);

	const getWorkflowOrgConfig = async (code: string) => {
		try {
			const {
				data: { data },
			} = await getFormFieldConfig(code);

			const jsonObject = JSON.parse(data[0]?.valueText);
			setConfig(jsonObject);
		} catch (error) {
			console.error(error);
		}
	};

	return {
		config,
	};
};

export default useWorkflowOrgConfig;
